import { initializeGalleries } from './fragments/gallery';
import { initializeLightbox } from './fragments/lightbox';
import { initializeHeader } from './fragments/header/header';
import { initializeHeaderNav } from './fragments/header/headerNav';
import { initializeHeaderOverlays } from './fragments/header/headerOverlays';
import { initializeAccordions } from './fragments/accordion/accordion';
import { initializeCarousels } from './fragments/carousel';
import { initializeNavigation } from './fragments/navigation/navigation';
import { initializeScrollToTopButton } from './fragments/scrolltotop';
import { initializeCheckboxes } from './fragments/checkbox';
import { initializePrint } from './helpers/print';
import { initializeSearch } from './fragments/search';
import { initializeMultiSelect } from './fragments/multiSelect';
import { initializePolyfills } from './global/polyfills';
import { initializeSimulations } from './global/simulations';

const initializationFunctions = [
  initializePolyfills,
  initializeCheckboxes,
  initializeNavigation,
  initializeHeader,
  initializeHeaderNav,
  initializeHeaderOverlays,
  initializeGalleries,
  initializeLightbox,
  initializeAccordions,
  initializeCarousels,
  initializeScrollToTopButton,
  initializePrint,
  initializeSearch,
  initializeMultiSelect,
  initializeSimulations, // only for demonstration purposes, remove for production
];

document.addEventListener('DOMContentLoaded', () => {
  initializationFunctions.forEach((initializationFunction) => {
    try {
      initializationFunction();
    } catch (error) {
      console.error(error);
    }
  });
});
